import type { ProfilePayoutDisplaySummary } from './profileAssetOwnerDisplay';
import { profileStorageKey } from './profileStorageKey';

const PROFILE_PAYOUT_WIRE_PREFIX = 'ofrontend.profilePayoutWireHints';

function safeGet(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function safeSet(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    /* ignore */
  }
}

export function getStoredProfilePayoutWireHints(
  loginId?: string | null,
): Record<string, unknown> | null {
  const raw = safeGet(profileStorageKey(PROFILE_PAYOUT_WIRE_PREFIX, loginId));
  if (!raw?.trim()) {
    return null;
  }
  try {
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      return parsed as Record<string, unknown>;
    }
  } catch {
    return null;
  }
  return null;
}

export function persistProfilePayoutWireHints(
  payload: Record<string, unknown>,
  loginId?: string | null,
): void {
  const accountNumber =
    typeof payload.account_number === 'string' ? payload.account_number.trim() : '';
  const toStore =
    accountNumber.includes('*')
      ? (() => {
          const { account_number: _omit, ...rest } = payload;
          return rest;
        })()
      : payload;
  safeSet(profileStorageKey(PROFILE_PAYOUT_WIRE_PREFIX, loginId), JSON.stringify(toStore));
}

export function mergeProfilePayoutSummaries(
  api: ProfilePayoutDisplaySummary | null,
  stored: ProfilePayoutDisplaySummary | null,
): ProfilePayoutDisplaySummary | null {
  if (!api && !stored) {
    return null;
  }
  if (!api) {
    return stored;
  }
  if (!stored) {
    return api;
  }
  return {
    payoutCountry: api.payoutCountry || stored.payoutCountry,
    accountHolderName: api.accountHolderName || stored.accountHolderName,
    bankNumber: api.bankNumber || stored.bankNumber,
    branchNumber: api.branchNumber || stored.branchNumber,
    accountNumber: api.accountNumber || stored.accountNumber,
    routingNumber: api.routingNumber || stored.routingNumber,
    accountType: api.accountType || stored.accountType,
    transferDay: api.transferDay ?? stored.transferDay,
  };
}
